import styles from "../../organizationMainStyles";
import React, {useState, useEffect} from "react";
import {Box} from "@mui/system";
import {Grid, Switch, TextField} from "@mui/material";
import _ from "lodash";
import {useDispatch} from "react-redux";
import {autoActionActions, organizationSettingsActions} from "../../../../../../_actions";
import {accessibilityMode} from "../organizationSettingsConstants";
import BasicButton from "../../../../common/BasicButton";
import {Typography} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import BasicTooltip from "../../../../common/BasicTooltip";

export default function MessageResponseDetails({autoAction, organizationId, mode, label}) {
    const [isActive, setIsActive] = useState(autoAction.isActive);
    const [isSkipEnabled, setIsSkipEnabled] = useState(autoAction.isSkipEnabled);
    const [isAutoReplyEnabled, setIsAutoReplyEnabled] = useState(autoAction.isAutoReplyEnabled);
    const [topics, setTopics] = useState(autoAction.topics);
    const [autoReplyText, setAutoReplyText] = useState(autoAction.autoReplyText);

    const dispatch = useDispatch();

    const isEditMode = () => {
        return mode === accessibilityMode.EDIT;
    };
    const handleAutoActionToggle = (event) => {
        const value = _.get(event, 'target.checked');
        setIsActive(value);
    }

    const handleSkipToggle = (event) => {
        const value = _.get(event, 'target.checked');
        setIsSkipEnabled(value);
    }

    const handleAutoReplyToggle = (event) => {
        const value = _.get(event, 'target.checked');
        setIsAutoReplyEnabled(value);
    }

    const handleTopicsChange = (event, index) => {
        topics[index] = event.target.value;

        setTopics([...topics])
    }

    const handleAutoRepliesChange = (event, index) => {
        autoReplyText[index] = event.target.value;

        setAutoReplyText([...autoReplyText])
    }


    const addTopic = () => {
        setTopics([...topics, ""])
    }
    const addAutoReply = () => {
        setAutoReplyText([...autoReplyText, ""])
    }

    const updateAutoAction = () => {
        const payload = {
            dataSourceHandleId: autoAction.dataSourceHandle.id,
            isActive: isActive,
            isSkipEnabled: isSkipEnabled,
            isAutoReplyEnabled: isAutoReplyEnabled,
            topics: topics,
            autoReplyText: autoReplyText,
        }

        dispatch(autoActionActions.createOrUpdateAutoActionFromMessageResponse(payload)).then(() => {
            dispatch(organizationSettingsActions.refreshAutoActionsInfo(organizationId));
        });
    }

    useEffect(() => {
        if(!autoAction.id) {
            setTopics([""])
            setAutoReplyText([""])
            setIsActive(true)
        }
    },[autoAction])

    return (
            <div>
                <Grid container>
                    { autoAction.id &&
                        <React.Fragment>
                            <Grid item xs={4}>
                                {label.AUTO_ACTION}
                            </Grid>
                            <Grid item xs={8}>
                                <Switch disabled={!isEditMode()} checked={isActive} onChange={handleAutoActionToggle} sx={styles.switch} />
                            </Grid>
                        </React.Fragment>
                     }
                    <Grid item xs={4}>
                        {label.SKIP_ENABLED}
                    </Grid>
                    <Grid item xs={8}>
                        <Switch disabled={!isEditMode()} checked={isSkipEnabled} onChange={handleSkipToggle} sx={styles.switch} />
                    </Grid>
                    <Grid item xs={4}>
                        {label.AUTO_REPLY_ENABLED}
                    </Grid>
                    <Grid item xs={8}>
                        <Switch disabled={!isEditMode()} checked={isAutoReplyEnabled} onChange={handleAutoReplyToggle} sx={styles.switch} />
                    </Grid>
                    <Grid item xs={4}>
                        {label.TOPICS}
                    </Grid>
                    <Grid item xs={8}>
                        {
                            topics.map((topic, index) =>
                                <div key={index}>
                                    <TextField key={index} disabled={!isEditMode()}
                                           value={topic} onChange={(event) => {
                                        handleTopicsChange(event, index);
                                    }}/>
                                </div>
                            )
                        }
                        { isEditMode() ?
                            <BasicButton disabled={!isEditMode()} label={"Add topic"}
                                    action={addTopic} style={{width: "200px", margin: "10px 0px"}} />
                            : null}
                    </Grid>
                    <Grid item xs={4}>
                        {label.AUTO_REPLIES}
                    </Grid>
                    <Grid item xs={8}>
                        {
                            autoReplyText.map((topic, index) =>
                                <div key={index}>
                                    <TextField key={index}  disabled={!isEditMode()}
                                           value={topic} onChange={(event) => {
                                        handleAutoRepliesChange(event, index);
                                    }}/>
                                </div>
                            )
                        }
                        { isEditMode() ?
                            <BasicButton disabled={!isEditMode()} label={"Add auto reply"}
                                    action={addAutoReply}  style={{width: "200px", margin: "10px 0px"}} />
                            : null}
                    </Grid>
                    <Grid item xs={4} sx={{margin: "10px 0px"}}>
                        {label.FIRST_RESPONSES}
                        <BasicTooltip
                            title={
                                <Box sx={{minWidth: '250px', maxWidth: '450px', padding: '10px'}}>
                                    <Typography sx={{width: '100%', fontSize: '15px', color: '#2C302E'}}>
                                        Enables an AI auto-responder to the first message
                                        in a given thread when the message queue is large.
                                        The AI auto-response will be based on the customer
                                        question.
                                    </Typography>
                                </Box>
                            }
                            placement={'bottom'}
                            style={{opacity: 1}}
                            enterDelay={700}
                        >
                            <Box sx={{display: 'inline-block', position: 'relative', top: '4px', ml: '5px'}}>
                                <InfoIcon sx={{fontSize: '18px'}}/>
                            </Box>
                        </BasicTooltip>
                    </Grid>
                    <Grid item xs={4} sx={{margin: "10px 0px"}}>
                        {label.AUTO_RESPONDER}
                    </Grid>
                </Grid>
                { isEditMode() ?
                    <BasicButton action={updateAutoAction} label={!autoAction.id ? "Create AutoAction" : "Update AutoAction"}
                                 style={{width: "200px", margin: "10px 0px"}}/>
                    : null}
            </div>
    );
}
